
const TrustStrip = () => {
  const trustBadges = [
    {
      icon: 'ri-pulse-line',
      text: 'Clinical Recovery Technology'
    },
    {
      icon: 'ri-building-line',
      text: 'Commercial Facility Solutions'
    },
    {
      icon: 'ri-flag-line',
      text: 'U.S. Distribution & Support'
    },
    {
      icon: 'ri-file-text-line',
      text: 'Procurement Documentation Available'
    }
  ];

  return (
    <section className="py-12 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustBadges.map((badge, index) => (
            <div 
              key={index}
              className="flex items-center justify-center gap-3 text-center"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${badge.icon} text-teal-600 text-xl`}></i>
              </div>
              <span className="text-gray-700 text-sm font-medium">
                {badge.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
